"use client";

import React, { useRef } from "react";

const fansData = [
  {
    id: 1,
    name: "Laura Kane",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-1.webp",
    testimonial:
      "After 5 months of guessing with LH strips, Inito pinpointed my true ovulation, and I conceived in just one cycle!",
  },
  {
    id: 2,
    name: "Leah Alissa Bayer",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-2.webp",
    testimonial:
      "With low AMH and no IVF options, Inito helped us conceive quickly. I learned more about my body than ever.",
  },
  {
    id: 3,
    name: "Amanda Young",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-3.webp",
    testimonial:
      "Despite struggling with hypothyroidism, Inito gave me invaluable insights. I went to my doctor well informed, and got pregnant in a month!",
  },
  {
    id: 4,
    name: "Cierra D",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-4.webp",
    testimonial:
      "Before Inito, I hadn't had a cycle in 8 months. Without Inito I would have assumed I wasn't ovulating and never would have known what days to try conceiving.",
  },
  {
    id: 5,
    name: "Morgan Fernandes",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-5.webp",
    testimonial:
      "After 5 years of trying, I finally conceived when I started using Inito! It helped me ensure that I ovulated & my hormones were on track after receiving fertility treatments.",
  },
  {
    id: 6,
    name: "Ashley",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-6.webp",
    testimonial:
      "After a miscarriage, Inito helped me nail my timing and understand my hormones far better than LH strips ever did.",
  },
  {
    id: 7,
    name: "Lauren Hart",
    image: "https://cdn.inito.com/rebrand_quiz/v1/result/newTestimonial-7.webp",
    testimonial:
      "After 2 years, IVF, and reversals, Inito finally helped us conceive by perfectly timing our chances. We owe it everything.",
  },
];

const FansSection: React.FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handlePointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    isDragging.current = true;
    if (carouselRef.current) {
      startX.current = e.clientX;
      scrollLeft.current = carouselRef.current.scrollLeft;
      carouselRef.current.setPointerCapture(e.pointerId);
    }
  };

  const handlePointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!isDragging.current || !carouselRef.current) return;
    e.preventDefault();
    const x = e.clientX;
    const walk = (x - startX.current) * 2;
    carouselRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handlePointerUpOrLeave = (e: React.PointerEvent<HTMLDivElement>) => {
    isDragging.current = false;
    if (carouselRef.current) {
      carouselRef.current.releasePointerCapture(e.pointerId);

      const gap = 15;
      const children = carouselRef.current.children;
      if (children.length > 0) {
        const cardWidth = (children[0] as HTMLElement).offsetWidth;
        const currentScroll = carouselRef.current.scrollLeft;

        const targetIndex = Math.round(currentScroll / (cardWidth + gap));
        const targetScrollLeft = targetIndex * (cardWidth + gap);
        carouselRef.current.scrollTo({
          left: targetScrollLeft,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <div className="w-full box-border bg-white flex flex-col items-start py-12 md:max-w-[500px]">
      <h2 className="w-full title-32 mb-6 text-[#232221] px-[30px] box-border md:mt-10 md:mb-3.5">
        Trusted by 100,000+ happy couples
      </h2>
      <div className="flex flex-row w-full tracking-[-0.4px] justify-start px-[30px] box-border">
        <div className="flex items-center flex-nowrap gap-x-1">
          <img
            src="https://cdn.inito.com/rebrand_quiz/v1/result/star.webp"
            alt="star"
            className="h-[13px] w-auto pr-2 shrink-0"
            draggable="false"
          />

          <p className="title-14 text-[#959594] flex items-center gap-1 whitespace-nowrap">
            4.3/5 on{" "}
            <img
              src="https://cdn.inito.com/rebrand_quiz/v1/result/amazon.svg"
              alt="amazon"
              className="w-[62px] h-6 pl-0.5 shrink-0"
              draggable="false"
            />
          </p>
          <p className="pl-1 title-14 text-[#959594] whitespace-nowrap md:pl-1.5">
            1,300+ reviews
          </p>
        </div>
      </div>

      <div
        className="flex overflow-x-auto gap-6 w-full mt-6 px-5 scroll-pl-5 snap-x snap-mandatory scrollbar-none md:cursor-grab md:active:cursor-grabbing md:select-none"
        ref={carouselRef}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUpOrLeave}
        onPointerLeave={handlePointerUpOrLeave}
      >
        {fansData.map((fan) => (
          <div
            key={fan.id}
            className="flex flex-col w-[312px] md:w-[320px] shrink-0 bg-white snap-start md:mb-5"
          >
            <div className="relative w-full max-h-[250px]">
              <img
                src={fan.image}
                alt={fan.name}
                draggable="false"
                className="w-full h-full object-cover object-center rounded-xl"
              />
            </div>
            <div className="body-17 pt-3.5 text-[#857E77]">
              {fan.name}
            </div>
            <p className="title-18 pt-1 mb-2 text-[#232221]">
              &quot;{fan.testimonial}&quot;
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FansSection;
